import { useRef, useEffect } from "react";

/**
 * Component that detects clicks outside of its children and calls a callback function.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onOutsideClick - Callback function called when a click outside is detected
 * @param {React.ReactNode} props.children - Content to render inside the component
 * @returns {React.ReactElement} The rendered component
 */
const OutsideClick = ({ onOutsideClick, children }) => {
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target)
            ) {
                onOutsideClick(event);
            }
        };

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup function
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onOutsideClick]);

    return <div ref={wrapperRef}>{children}</div>;
};

export default OutsideClick;
